"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPresenceLeaf = exports.PresenceLeaf = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Caret_1 = require("./Caret");
/**
 * A `renderLeaf` component that layers remote presence visuals (caret +
 * selection highlight) on top of the app's own leaf rendering.
 *
 * Wrap your existing `renderLeaf` with {@link withPresenceLeaf} for the
 * easiest integration, or use this component directly if you prefer manual
 * control.
 */
const PresenceLeaf = ({ attributes, children, leaf }) => {
    const highlight = leaf.presenceHighlight;
    const caret = leaf.presenceCaret;
    const style = highlight ? { backgroundColor: highlight } : undefined;
    return (React.createElement("span", { ...attributes, style: style },
        caret ? React.createElement(Caret_1.Caret, { info: caret }) : null,
        children));
};
exports.PresenceLeaf = PresenceLeaf;
/**
 * Higher-order function that wraps an application's `renderLeaf` component to
 * also render remote-presence caret and selection-highlight decorations.
 *
 * Usage:
 *
 * ```tsx
 * const renderLeaf = withPresenceLeaf((props) => <MyLeaf {...props} />);
 * <Editable renderLeaf={renderLeaf} />
 * ```
 */
const withPresenceLeaf = (AppLeaf) => {
    const Wrapped = (props) => {
        const leaf = props.leaf;
        const highlight = leaf.presenceHighlight;
        const caret = leaf.presenceCaret;
        // If no presence decorations on this leaf, just render the app leaf.
        if (!highlight && !caret)
            return React.createElement(AppLeaf, { ...props });
        // Wrap the app's leaf output with presence visuals.
        const style = highlight ? { backgroundColor: highlight } : undefined;
        return (React.createElement("span", { ...props.attributes, style: style },
            caret ? React.createElement(Caret_1.Caret, { info: caret }) : null,
            React.createElement(AppLeaf, { ...props })));
    };
    return Wrapped;
};
exports.withPresenceLeaf = withPresenceLeaf;
